import React, { Component, Fragment } from 'react'
import { Translate } from '../../contexts/Language';
import { Card, BreadCrumb, Modal } from '../../components';
import DataTable from 'react-data-table-component'
import { DataTableColumns } from '../../config/DataTableColumns';
import { Config } from '../../config';
import { Service } from '../../services';
import Select from 'react-select';
import { ErrorMessage, Validator, VRules, VConditions } from '../../components/Validator';

export class PaymentServices extends Component {

    constructor(props) {
        super(props)

        this.Refs = React.createRef();

        this.state = {
            dataTable: {
                columns: DataTableColumns.transferOptions,
                rows: []
            },
            dataTableDeposit: {
                columns: DataTableColumns.transferOptionsTab,
                rows: []
            },
            dataTableWithdrawal: {
                columns: DataTableColumns.transferOptionsTab,
                rows: []
            },
            modal: false,
            modalTitle: "",
            validation: {
                error: false,
                message: ""
            },
            formData: {
                id: 0,
                outside: false,
                auto: false,
                acceptedCurrencies: [],
                title: "",
                url: "",
                processingTime: "",
                fee: ""
            }
        }

        this.options = [
            { value: 'NONE', label: "None" },
            { value: 'W', label: "Withdrawal" },
            { value: 'D', label: "Deposit" },
            { value: 'B', label: "Both" }
        ];

        this.currencies = [];

        this.onEdit = this.onEdit.bind(this);
    }
    componentDidMount() {
        this.onDataTable();
    }
    onDataTable() {

        Config.utilities.loadingFetch();

        Service.TransferOptions.List().then(response => {

            if (response) {

                let deposit = response.filter(item => item.deposit === true),
                    withdrawal = response.filter(item => item.withdrawal === true);

                let dataTable = this.state.dataTable,
                    dataTableDeposit = this.state.dataTableDeposit,
                    dataTableWithdrawal = this.state.dataTableWithdrawal;

                dataTable.rows = response;
                dataTableDeposit.rows = deposit;
                dataTableWithdrawal.rows = withdrawal;

                this.setState({
                    dataTable: dataTable,
                    dataTableDeposit: dataTableDeposit,
                    dataTableWithdrawal: dataTableWithdrawal
                });

            }

            Service.TransferOptions.CurrencyList().then(response => {

                if (response) {
                    this.currencies = response.map(item => ({ value: item.id, label: item.title }))
                }

                Config.utilities.loadingFetch();
            });


        });
    }
    onFormChange(value, key) {

        let formData = this.state.formData;

        formData[key] = value;

        this.setState({
            formData
        });
    }
    onNew() {
        this.setState(
            {
                modal: true,
                modalTitle: Translate("Edit Payment Service"),
                validation: {
                    error: false,
                    message: ""
                },
                formData: {
                    id: 0,
                    outside: false,
                    acceptedCurrencies: [],
                    title: "",
                    url: "",
                    processingTime: "",
                    fee: ""
                }
            });

    }
    onEdit(id) {


        Config.utilities.loadingFetch();

        this.setState(
            {
                modal: true,
                modalTitle: Translate("Edit Payment Service"),
                validation: {
                    error: false,
                    message: ""
                },
                formData: {
                    id: 0,
                    outside: false,
                    acceptedCurrencies: [],
                    title: "",
                    url: "",
                    processingTime: "",
                    fee: ""
                }
            });


        Service.TransferOptions.Detail(id).then(response => {

            if (response) {

                let formData = this.state.formData;

                formData = { ...response };

                formData.options = this.options.filter(f => f.value === formData.options)[0];
                formData.acceptedCurrencies = formData.acceptedCurrencies.map(item => ({ value: item, label: this.currencies.filter(f => f.value === item)[0].label }))

                this.setState({
                    formData
                });
            }

            Config.utilities.loadingFetch();
        })


    }
    onSave() {



        let formData = Object.assign({}, this.state.formData);

        formData.options = formData.options ? formData.options.value : "";
        formData.acceptedCurrencies = formData.acceptedCurrencies.map(item => item.value);


        if (this.isValid(formData)) {
            Config.utilities.loadingFetch();

            Service.TransferOptions.Save(formData).then(response => {

                if (response.error) {
                    this.setState({
                        validation: {
                            error: response.error,
                            message: response.message
                        }
                    });
                }
                else {
                    this.onDataTable();
                    this.setState({
                        modal: false
                    });
                }

                Config.utilities.loadingFetch();
            });
        }
    }
    isValid(data) {


        VRules["title"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Title can not be empty.")
        }

        VRules["url"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Title can not be empty.")
        }

        VRules["processingTime"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Processing Time can not be empty.")
        }

        VRules["fee"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Fee can not be empty.")
        }

        VRules["acceptedCurrencies"] = {
            Invalid: (value) => {
                return VConditions.RequiredArray(value)
            },
            Message: Translate("Accepted Currencies can not be empty.")
        }

        VRules["options"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Options can not be empty.")
        }



        let error = Validator.Valid(data, this.Refs);

        this.setState({
            validation: error
        });

        return !error.error;
    }
    render() {
        return (
            <Fragment>
                <BreadCrumb Title={Translate("Payment Services")} Name={Translate("Payment Services")} />
                <Modal Title={this.state.modalTitle} Show={this.state.modal} onClose={(e) => this.setState({ modal: false })}>
                    <div className="row mt-1 mb-1">
                        <p className="text-muted mb-2 ml-1 col-md-12 font-12">Role Information</p>
                        <div className="col-md-12">
                            <form className="form-horizontal" name="saveForm" ref={this.Refs}>
                                <ErrorMessage Validation={this.state.validation} />
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="title" className="col-sm-4 col-form-label">Title</label>
                                    <div className="col-sm-8">
                                        <input className="form-control" type="text" id="title" name="title" value={this.state.formData.title} onChange={(e) => this.onFormChange(e.target.value, e.target.name)} />
                                    </div>
                                </div>
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="description" className="col-sm-4 col-form-label">Description</label>
                                    <div className="col-sm-8">
                                        <input className="form-control" type="text" id="description" name="description" value={this.state.formData.description} onChange={(e) => this.onFormChange(e.target.value, e.target.name)} />
                                    </div>
                                </div>
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="logo" className="col-sm-4 col-form-label">Logo</label>
                                    <div className="col-sm-8">
                                        <input className="form-control" type="text" id="logo" name="logo" value={this.state.formData.logo} onChange={(e) => this.onFormChange(e.target.value, e.target.name)} />
                                    </div>
                                </div>
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="url" className="col-sm-4 col-form-label">Url</label>
                                    <div className="col-sm-8">
                                        <input className="form-control" type="text" id="url" name="url" value={this.state.formData.url} onChange={(e) => this.onFormChange(e.target.value, e.target.name)} />
                                    </div>
                                </div>
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="optionKey" className="col-sm-4 col-form-label">Key</label>
                                    <div className="col-sm-8">
                                        <input className="form-control" type="text" id="optionKey" name="optionKey" value={this.state.formData.optionKey} onChange={(e) => this.onFormChange(e.target.value, e.target.name)} />
                                    </div>
                                </div>
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="acceptedCurrencies" className="col-sm-4 col-form-label">Accepted Currencies</label>
                                    <div className="col-sm-8">
                                        <Select
                                            id="acceptedCurrencies"
                                            value={this.state.formData.acceptedCurrencies}
                                            onChange={(option) => this.onFormChange(option, "acceptedCurrencies")}
                                            options={this.currencies}
                                            isMulti={true}
                                            name="acceptedCurrencies"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="processingTime" className="col-sm-4 col-form-label">Processing Time</label>
                                    <div className="col-sm-8">
                                        <input className="form-control" type="text" id="processingTime" name="processingTime" value={this.state.formData.processingTime} onChange={(e) => this.onFormChange(e.target.value, e.target.name)} />
                                    </div>
                                </div>
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="fee" className="col-sm-4 col-form-label">Fee</label>
                                    <div className="col-sm-8">
                                        <input className="form-control" type="text" id="fee" name="fee" value={this.state.formData.fee} onChange={(e) => this.onFormChange(e.target.value, e.target.name)} />
                                    </div>
                                </div>
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="options" className="col-sm-4 col-form-label">Options</label>
                                    <div className="col-sm-8">
                                        <Select
                                            id="transferType"
                                            value={this.state.formData.options}
                                            onChange={(option) => this.onFormChange(option, "options")}
                                            options={this.options}
                                            isMulti={false}
                                            name="options"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="fee" className="col-sm-4 col-form-label">Outside</label>
                                    <div className="col-sm-8">
                                        <input type="checkbox" id="outside" name="outside" switch="dark" checked={this.state.formData.outside} onChange={(e) => this.onFormChange(!this.state.formData.outside, e.target.name)} />
                                        <label htmlFor="outside" data-on-label="Yes" data-off-label="No" className="mt-2 mb-1"></label>
                                    </div>
                                </div>
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="fee" className="col-sm-4 col-form-label">Auto Transfer</label>
                                    <div className="col-sm-8">
                                        <input type="checkbox" id="auto" name="auto" switch="dark" checked={this.state.formData.auto} onChange={e => this.onFormChange(!this.state.formData.auto, e.target.name)} />
                                        <label htmlFor="auto" data-on-label="Yes" data-off-label="No" className="mt-2 mb-1" />
                                    </div>
                                </div>
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="save-form" className="col-sm-4 col-form-label"></label>
                                    <div className="col-sm-8">
                                        <button type="button" className="btn btn-info float-right" onClick={(e) => this.onSave()}><i className="far fa-save mr-1"></i> Save Form</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal>
                <Card Title="Customer Payment Services" Description="Customer panel payment systems.">
                    <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
                        <li className="nav-item">
                            <a className="nav-link active" data-toggle="tab" href="#psp" role="tab">
                                <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                <span className="d-none d-sm-block">{Translate('Payment Service Providers')}</span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" data-toggle="tab" href="#deposit" role="tab">
                                <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                                <span className="d-none d-sm-block">Deposit</span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" data-toggle="tab" href="#withdrawal" role="tab">
                                <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                <span className="d-none d-sm-block">Withdrawal</span>
                            </a>
                        </li>
                        <button type="button" className="btn btn-info position-absolute add-new-button" onClick={(e) => this.onNew()}><i className="fas fa-plus"></i> Add New Payment Service</button>
                    </ul>

                    <div className="tab-content">
                        <div className="tab-pane active p-3" id="psp" role="tabpanel">
                            <div className="row">
                                <div className="col-md-12">
                                    {this.state.dataTable.rows.length === 0 ? (
                                        <div className="alert alert-light" role="alert">
                                            <em><strong>No record!</strong> {Translate('No records found for the filter.')} </em>
                                        </div>) :
                                        (<DataTable
                                            noHeader={true}
                                            columns={this.state.dataTable.columns(this.onEdit)}
                                            data={this.state.dataTable.rows}
                                            defaultSortField="id"
                                            defaultSortAsc={false}
                                            pagination
                                            highlightOnHover />)}
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane p-3" id="deposit" role="tabpanel">
                            <div className="row">
                                <div className="col-md-12">
                                    {this.state.dataTableDeposit.rows.length === 0 ? (
                                        <div className="alert alert-light" role="alert">
                                            <em><strong>No record!</strong> {Translate('No records found for the filter.')} </em>
                                        </div>) :
                                        (<DataTable
                                            noHeader={true}
                                            columns={this.state.dataTableDeposit.columns}
                                            data={this.state.dataTableDeposit.rows}
                                            defaultSortField="id"
                                            defaultSortAsc={false}
                                            pagination
                                            highlightOnHover />)}
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane p-3" id="withdrawal" role="tabpanel">
                            <div className="row">
                                <div className="col-md-12">
                                    {this.state.dataTableWithdrawal.rows.length === 0 ? (
                                        <div className="alert alert-light" role="alert">
                                            <em><strong>No record!</strong> {Translate('No records found for the filter.')} </em>
                                        </div>) :
                                        (<DataTable
                                            noHeader={true}
                                            columns={this.state.dataTableWithdrawal.columns}
                                            data={this.state.dataTableWithdrawal.rows}
                                            defaultSortField="id"
                                            defaultSortAsc={false}
                                            pagination
                                            highlightOnHover />)}
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
            </Fragment>)
    }
}